webpackJsonp([97],{

/***/ 1084:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(341)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"SlideImage1.s.scss","sourceRoot":""}]);

// exports


/***/ }),

/***/ 402:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1084);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(342)("4846f6ee", content, true, {});

/***/ })

});


// WEBPACK FOOTER //
// static/js/97.77cfa8669ae9908a832c.js